import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";
import { getDeclination } from "Utils/text";
import OperatorItemBasis from "./OperatorItemBasis";
import { styles } from "./OperatorItemStyles";

class OperatorItem extends OperatorItemBasis {
	render() {
		const { data: item, classes, text } = this.props;

		return (
			<div
				className={classNames(classes.root, {
					[classes.isElite]: item.vip_provider == 1,
					[classes.isFlat]: this.props.flat,
					[classes.lowHeight]: Object.keys(item.info).length === 0 && !this.props.flat,
				})}
				datatest="operators_operator_button"
			>
				<div className={classes.wrapper}>
					<div className={classes.infoWrapper}>
						{this.generateLogo(item)}
						<div className={classes.infoNameWrapper}>
							<div className={classes.nameWrapper}>
								<div className={classes.name}>{item.name}</div>
							</div>

							{!!item.info.cnt_tariffs &&
								React.cloneElement(this.props.linkComponent, {
									to: this.props.generateOperatorTariffUrl(item),
									className: classes.name,
									children: (
										<div className={classes.amountTariffsWrapper}>
											<div className={classes.subtext}>
												{`${item.info.cnt_tariffs} ${getDeclination(
													item.info.cnt_tariffs,
													text.TARIFFS_1,
													text.TARIFFS_2,
													text.TARIFFS
												)}`}
											</div>
										</div>
									),
								})}
							{!!item.info.cnt_action_tariffs &&
								item.info.cnt_action_tariffs > 0 &&
								React.cloneElement(this.props.linkComponent, {
									to: this.props.generateOperatorTariffActionsUrl(item),
									className: classes.name,
									children: (
										<div className={classes.amountTariffsWrapper}>
											{item.info.cnt_action_tariffs > 0 && (
												<div className={classes.subtext}>
													{`${item.info.cnt_action_tariffs} ${getDeclination(
														item.info.cnt_action_tariffs,
														text.ACTIONS_1,
														text.ACTIONS_2,
														text.ACTIONS
													)}`}
												</div>
											)}
										</div>
									),
								})}
						</div>
					</div>

					{!!item.info.cnt_tariffs && (
						<div className={classes.measuresWrapper}>
							{(!!item.info.max_minutes || !!item.info.max_minutes == 0) && (
								<div className={classes.name}>
									<div className={classes.priceWrapper}>
										<div className={classes.mainText}>
											{`${text.TO} ${item.info.max_minutes}`}
											<span className={classes.subtextMeasure}>{text.min}</span>
										</div>
										{/*<div className={classes.subtext}>*/}
										{/*    {text.min}*/}
										{/*</div>*/}
									</div>
								</div>
							)}

							{!!item.info.max_gigabytes && (
								<div className={classes.name}>
									<div className={classes.speedWrapper}>
										<div className={classes.mainText}>
											{`${text.TO} ${item.info.max_gigabytes}`}
											<span className={classes.subtextMeasure}>{text.gb}</span>
										</div>
										{/*<div className={classes.subtext}>*/}
										{/*    {text.gb}*/}
										{/*</div>*/}
									</div>
								</div>
							)}
						</div>
					)}

					{this.generateButton()}
				</div>
				{this.generateCommonPart()}
			</div>
		);
	}
}

export default withStyles(styles)(OperatorItem);
